import Vue from "vue";
import "swiper/swiper.min.css";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "./style/main.less";
import "./utils/dependence";
import "locomotive-scroll/dist/locomotive-scroll.css";
import VueLazyload from "vue-lazyload";
import Element from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
//mock
// require("./mock");
import "lib-flexible";

Vue.use(Element);
Vue.use(VueLazyload);
Vue.config.productionTip = false;
Vue.config.devtools = process.env.NODE_ENV === "development";

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
